type UserIdentifier = number | string | null | undefined;

export function isResourceCreator({
  createdByUserId,
  currentUserId,
}: {
  createdByUserId: UserIdentifier;
  currentUserId: UserIdentifier;
}): boolean {
  // Hasura and app user ids do not always arrive with the same primitive type.
  return (
    createdByUserId != null &&
    currentUserId != null &&
    String(createdByUserId) === String(currentUserId)
  );
}

export function isPermissionsTabAccessible({
  resource,
  user,
  eventsRbacEnabled,
  permissions,
}: {
  eventsRbacEnabled: boolean;
  resource?: { created_by_user?: { id?: UserIdentifier } | null };
  user?: { id?: UserIdentifier };
  permissions: { isPermitted: boolean; isLoading: boolean };
}): boolean {
  if (!eventsRbacEnabled || permissions.isLoading) {
    return false;
  }
  if (permissions.isPermitted) {
    return true;
  }
  return isResourceCreator({
    createdByUserId: resource?.created_by_user?.id,
    currentUserId: user?.id,
  });
}
